var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["generic-email-error-message.j2"] = require( "generic-email-error-message.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/generic-email-service-errors.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"state") == "submitted") {
output += "\n    <div class=\"o-row\">\n        <div class=\"o-column o-extra-small--12\">\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"error") == true) {
output += "\n\n                ";
env.getTemplate("generic-email-error-message.j2", false, "core/templates/generic-email-service-errors.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n            ";
})});
}
else {
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFormConfig")),"successModules")) {
output += "\n                <div class=\"c-form__field has-success\">\n                    <div class=\"c-form-block\">\n                        <p class=\"c-form-block__p\">\n                            ";
output += runtime.suppressValue((lineno = 11, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["generic-email-" + "" + runtime.contextOrFrameLookup(context, frame, "form_slug") + "" + "_success-message"])), env.opts.autoescape);
output += "\n                        </p>\n                    </div>\n                </div>\n            ";
;
}
;
}
output += "\n        </div>\n    </div>\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/generic-email-service-errors.j2"] , dependencies)